<svg class="absolute bottom-0 left-0 w-full h-full"
     viewBox="0 0 1183 642"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     preserveAspectRatio="xMinYMax slice"
     [ngClass]="isSidebar ? 'sidebar-svg-class' : 'non-sidebar-svg-class'">
  <g>
    <path
      d="M161.769 632.384L627.058 1.46869L-48.1846 1.46875C-110.444 1.46875 -168.727 32.0668 -204.083 83.3138L-636 709.369L9.33795 709.369C69.4904 709.369 126.066 680.795 161.769 632.384Z"
      fill="url(#paint0_linear_5490_44606)" fill-opacity="0.15"></path>
    <path
      d="M161.769 632.384L627.058 1.46869L-48.1846 1.46875C-110.444 1.46875 -168.727 32.0668 -204.083 83.3138L-636 709.369L9.33795 709.369C69.4904 709.369 126.066 680.795 161.769 632.384Z"
      stroke="url(#paint1_linear_5490_44606)" stroke-width="2.93734"></path>
  </g>
  <g>
    <path
      d="M563.446 1096.6L1179.28 262.893L280.551 262.893C218.341 262.893 160.098 293.442 124.733 344.621L-448.01 1173.47L411.101 1173.47C471.202 1173.47 527.737 1144.94 563.446 1096.6Z"
      fill="url(#paint2_linear_5490_44606)" fill-opacity="0.1"></path>
    <path
      d="M563.446 1096.6L1179.28 262.893L280.551 262.893C218.341 262.893 160.098 293.442 124.733 344.621L-448.01 1173.47L411.101 1173.47C471.202 1173.47 527.737 1144.94 563.446 1096.6Z"
      stroke="url(#paint3_linear_5490_44606)" stroke-width="2.93734"></path>
  </g>
  <defs>
    <linearGradient id="paint0_linear_5490_44606" x1="-330.516" y1="890.015" x2="328.917" y2="-170.366"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="white"></stop>
      <stop offset="1" stop-color="white" stop-opacity="0"></stop>
    </linearGradient>
    <linearGradient id="paint1_linear_5490_44606" x1="-547.191" y1="829.988" x2="464.832" y2="3.40008"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="white"></stop>
      <stop offset="1" stop-color="white" stop-opacity="0.1"></stop>
    </linearGradient>
    <linearGradient id="paint2_linear_5490_44606" x1="142.396" y1="1141.16" x2="691.679" y2="262.893"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="white"></stop>
      <stop offset="1" stop-color="white" stop-opacity="0"></stop>
    </linearGradient>
    <linearGradient id="paint3_linear_5490_44606" x1="-333.591" y1="1328.62" x2="968.597" y2="263.33"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="white"></stop>
      <stop offset="1" stop-color="white" stop-opacity="0.1"></stop>
    </linearGradient>
  </defs>
</svg>